const TRUE_VALUES = new Set(["1", "true", "yes", "on"]);

interface DevUserTranscriptOptions {
  nodeEnv?: string;
  flagValue?: string;
}

export function shouldShowDevUserTranscripts({
  nodeEnv = process.env.NODE_ENV,
  flagValue = process.env.NEXT_PUBLIC_SHOW_USER_TRANSCRIPTS_DEV,
}: DevUserTranscriptOptions = {}): boolean {
  if (nodeEnv === "production") {
    return false;
  }

  return TRUE_VALUES.has(
    String(flagValue || "")
      .trim()
      .toLowerCase()
  );
}
